import { plainToInstance } from 'class-transformer';
import { observer } from 'mobx-react-lite';
import { useCallback, useMemo, useState } from 'react';
import { PromotionService } from '~/service/service.promotion';
import { UIService } from '~/service/service.ui';
import { PromotionOfferDto } from '~/shared/dto/admin/promotion.dto';
import { Form } from '~/shared/form';
import { useService } from '~/shared/service/service.base';
import { PromotionOfferDialog } from '../dialog/dialog.promotion.fragrance';
import { PromotionDraggableList } from './promotion.list';

export type PromotionOffersProps = {
	field: Form.Field<PromotionOfferDto[]>;
};

export const PromotionOffers = observer(({ field }: PromotionOffersProps) => {
	const [ui, promotion] = useService(UIService, PromotionService);
	const [initial, setInitial] = useState<PromotionOfferDto | undefined>(undefined);

	const handleApply = useCallback(
		(offer: PromotionOfferDto) => {
			const arr = Array.from(field.value || []);
			const index = arr.findIndex(o => o.fragranceId === offer.fragranceId);
			if (index >= 0) arr[index] = offer;
			else {
				offer.order = arr.length + 1;
				arr.push(offer);
			}
			field.set(arr);
		},
		[field],
	);

	const hadnleAdd = useMemo(() => {
		return (offer?: PromotionOfferDto) => {
			setInitial(offer || plainToInstance(PromotionOfferDto, { order: 1 }));
			ui.showDialog(PromotionOfferDialog);
		};
	}, [ui]);

	const handleDelete = useCallback(
		(offer: PromotionOfferDto) => {
			const arr = field.value?.filter(o => o.fragranceId !== offer.fragranceId) || [];
			arr.forEach((item, idx) => (item.order = idx + 1));
			field.set(arr);
		},
		[field],
	);

	const fragrances = promotion.fragrances.map(f => ({
		...f,
		active: f.active && !field.value?.some(o => o.fragranceId === f.id),
	}));

	return (
		<>
			<PromotionDraggableList
				label="Promo offers"
				field={field}
				onAdd={hadnleAdd}
				onEdit={hadnleAdd}
				onDelete={handleDelete}
			/>
			<PromotionOfferDialog fragrances={fragrances} initial={initial} onApply={handleApply} />
		</>
	);
});
